import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=2a5fe3cf"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5fe3cf')) {
      api.createRecord('2a5fe3cf', component.options)
    } else {
      api.reload('2a5fe3cf', component.options)
    }
    module.hot.accept("./Master.vue?vue&type=template&id=2a5fe3cf", function () {
      api.rerender('2a5fe3cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Master.vue"
export default component.exports